// App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './firebase/AuthContext';
import React from 'react';
import Modal from 'react-modal';

import LoginForm from './components/Login/LoginForm';
import ForgotPassword from './components/Login/ForgotPassword';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './firebase/ProtectedRoute';

import AdminDashboard from './components/AdminDashboard';
import MakeMeAdmin from './components/MakeMeAdmin';
import AdminUsers from './components/AdminUsers';
import MassUpload from './components/MassUpload';
import CSVUploader from './components/CSVUploader';
import DeleteManufacturingData from './components/DeleteManufactureData';
import MassDownload from './components/MassDownload';
import CylInfoSearch from './components/CylInfoSearch';

// Warehouse (only ones not removed by your error list)
import WarehouseDashboard from './components/WarehouseDashboard';
import WarehouseView from './components/WarehouseView';
import WarehouseBookingInForm from './components/WarehouseBookingInForm';
import WarehouseBookingStock from './components/WarehouseBookingStock';
import WarehouseBookingOutForm from './components/WarehouseBookingOutForm';
import WarehouseMoveForm from './components/WarehouseMoveForm';
import WarehouseDelete from './components/WarehouseDelete';
import WarehouseArchive from './components/WarehouseArchive';
import WarehouseSyncFromStocktake from './components/WarehouseSyncFromStocktake';
import WarehouseMultiBookOut from './components/WarehouseMultiBookOut';
import WarehouseAgedBookOut from './components/WarehouseAgedBookOut';

// Returns
import ReturnsDashboard from './components/ReturnsDashboard';
import ReturnsEntry from './components/ReturnsEntry';
import PartsReturnEntry from './components/PartsReturnEntry';
import ReturnsList from './components/ReturnsList';
import ReturnsDrafts from './components/ReturnsDraft';
import CodesManager from './components/CodesManager';
import PartTemplatesManager from './components/PartTemplatesManager';

// New Returns
import ReturnsDashboardDupe from './components/ReturnsDashboardDupe';

// Despatch
import DespatchDashboard from './components/DespatchDashboard';
import DespatchReport from './components/DespatchReport';
import DespatchView from './components/DespatchView';
import DespatchDetailView from './components/DespatchDetailView';
import DespatchSummary from './components/DespatchSummary';

// Maintenance / PPM / Machines
import MaintenanceDashboard from './components/MaintenanceDashboard';
import MaintenanceDashboardSec from './components/MaintenanceDashboardSec';
import WorkRequest from './components/WorkRequest';
import JobsAndRequests from './components/JobsAndRequests';
import PhotoGallery from './components/PhotoGallery';
import ArchiveBlock from './components/ArchiveBlock';
import AssetPPMDesigner from './components/AssetPPMDesigner';
import PPMViewerPro from './components/PPMViewerPro';
import BreakdownArchive from './components/BreakdownArchive';
import ManageMachines from './components/ManageMachines';
import Machines from './components/Machines';
import JobList from './components/JobList';
import PPMAssetCreate from './components/PPMAssetCreate';

// Stocktake
import StockComparison from './components/StockComparison';
import StockTakeForm from './components/StockTakeForm';
import StocktakeDashboard from './components/StocktakeDashboard';
import DeadStockView from './components/DeadStockView';
import ClearStocktakeScanned from './components/ClearStocktakeScanned';
import ClearOldStocktakeScanned from './components/ClearOldStocktakeScanned';
import StocktakeToDuplicate from './components/StocktakeToDuplicate';
import PublishDuplicateToLive from './components/PublishDuplicateToLive';
import StocktakeInstructions from './components/StocktakeInstructions';
import DuplicateWarehouse from './components/DuplicateWarehouse';

// Sales / Technical
import SalesDashboard from './components/SalesDashboard';
import HelpDeskDashboard from './components/HelpDeskDashboard';
import PartsList from './components/PartsList';
import PartsPrices from './components/PartsPrices';
import QuoteList from './components/QuoteList';
import CopperQuote from './components/CopperQuote';
import StainlessUnventedQuote from './components/StainlessUnventedQuote';
import StainlessVentedQuote from './components/StainlessVentedQuote';
import StockAllocation from './components/StockAllocation';
import TechnicalDashboard from './components/TechnicalDashboard';
import TechnicalCalculator from './components/TechnicalCalculator';
import HeatUpCalculator from './components/HeatUpCalculator';
import TimeRequiredCalculator from './components/TimeRequiredCalculator';
import CylinderSizingCalculator from './components/CylinderSizingCalculator';
import ExpansionVesselCalculator from './components/ExpansionVesselCalculator';
import SalesWarehouse from './components/SalesWarehouse';
import MerchantMap from './components/MerchantMap';
import SketchPads from './components/SketchPads';
import SalesRepSearch from './components/SalesRepSearch';
import Quoting from './components/Quoting';
import SizingList from './components/SizingList';
import CombiSizing from './components/CombiSizing';
import CylinderSizing from './components/CylinderSizing';
import StainlessCylinderSizing from './components/StainlessCylinderSizing';
import LeadTimeManager from './components/LeadTimeManager';

// Production
import ProductionDashboard from './components/ProductionDashboard';
import DailyProduction from './components/DailyProduction';
import EmailVerification from './components/EmailVerification';
import AdminUserVerification from './components/AdminUserVerification';
import ReturnsArchive from './components/ReturnsArchive';
import SalesRepManager from './components/SalesRepManager';

import FittingDashboard from './components/FittingDashboard';
import FittingShopQrList from './components/FittingShopQrList';
import FittingShopQrUpload from './components/FittingShopQrUpload';

import PTIM from './components/PTIM';
import DatasheetManager from './components/DatasheetManager';
import PartsManager from './components/PartsManager';
import PPMEngineersAdmin from './components/PPMEngineersAdmin';
import PPMScheduleJobs from './components/PPMScheduleJobs';
import PPMAssetsList from './components/PPMAssetsList';
import PPMDailySchedule from './components/PPMDailySchedule';
import PPMEngineerPortal from './components/PPMEngineerPortal';
import PPMPrintSchedule from './components/PPMPrintSchedule';
import PPMCompletedJobs from './components/PPMCompletedJobs';
import EngineerDashboard from './components/EngineerDashboard';
import ReturnsEntryV2 from './components/ReturnsEntryV2';
import StragglerExport from './components/StragglerExport';
import ReturnsPartsEntryV2 from './components/ReturnsPartsEntryV2';
import ReturnsCylinderEntryV2 from './components/ReturnsCylinderEntryV2';
import ReturnsViewerV2 from './components/ReturnsViewerV2';
import ReturnsDraftMigratorCylToV2 from './components/ReturnsDraftMigratorCylToV2';
import ReturnsMigratorAllToV2 from './components/ReturnsMigratorAllToV2';
import ReturnsArchiveViewerV2 from './components/ReturnsArchiveViewerV2';
import ReturnsV2DedupeCleaner from './components/ReturnsV2DedupeCleaner';
import ReturnsV2ExcelExporter from './components/ReturnsV2ExcelExporter';
import ThermalStoreTool from './components/ThermalStoreTool';
import CoilTool from './components/CoilTool';
import StockSalesWarehouseLinker from './components/StockSalesWarehouseLinker';
import StockMinLevels from './components/StockMinLevels';
import StockMinLevelsBulkAdd from './components/StockMinLevelsBulkAdd';
import CylInfoExcelManager from './components/CylInfoExcelManager';
import StockWarehouseMatcher from './components/StockWarehouseMatcher';
import PPMExport from './components/PPMExport';
import FittingShopQrListDelete from './components/FittingShopQrListDelete';
import FactoryBarcodeSearch from './components/FactoryBarcodeSearch';
import CylinderMovementReport from './components/CylinderMovementReport';
import DespatchWarehouseReport from './components/DespatchWarehouseReport';
import BarcodeTrackingReport from './components/BarcodeTrackingReport';
import CustomerStockReport from './components/CustomerStockReport';

Modal.setAppElement('#root');

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LoginForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Core */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin */}
          <Route
            path="/AdminDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MakeMeAdmin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MakeMeAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AdminUsers"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CylInfoSearch"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <CylInfoSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MassUpload"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MassUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MassDownload"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MassDownload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CylinderMovementReport"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <CylinderMovementReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DespatchWarehouseReport"
            element={
              <ProtectedRoute allowedRoles={['admin', 'warehouse']}>
                <DespatchWarehouseReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/BarcodeTracking"
            element={
              <ProtectedRoute allowedRoles={['admin', 'warehouse', 'office']}>
                <BarcodeTrackingReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DeleteManufactureData"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <DeleteManufacturingData />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CodesManager"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <CodesManager />
              </ProtectedRoute>
            }
          />

          {/* Warehouse */}
          <Route
            path="/WarehouseDashboard"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseView"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseBookingInForm"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseBookingInForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseBookingStock"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseBookingStock />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseBookingOutForm"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseBookingOutForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseMoveForm"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <WarehouseMoveForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseDelete"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <WarehouseDelete />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseArchive"
            element={
              <ProtectedRoute allowedRoles={['admin', 'internal']}>
                <WarehouseArchive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseSyncFromStocktake"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <WarehouseSyncFromStocktake />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StockWarehouseMatcher"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <StockWarehouseMatcher />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseMultiBookOut"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <WarehouseMultiBookOut />
              </ProtectedRoute>
            }
          />
          <Route
            path="/WarehouseAgedBookOut"
            element={
              <ProtectedRoute allowedRoles={['internal', 'admin']}>
                <WarehouseAgedBookOut />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FactoryBarcodeSearch"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <FactoryBarcodeSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EmailVerification"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <EmailVerification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AdminUserVerification"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminUserVerification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PTIM"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <PTIM />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FittingShopQrListDelete"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <FittingShopQrListDelete />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DatasheetManager"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <DatasheetManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PartsManager"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <PartsManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesRepManager"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <SalesRepManager />
              </ProtectedRoute>
            }
          />
          
          {/* Fitting */}
          <Route
            path="/FittingDashboard"
            element={
              <ProtectedRoute allowedRoles={['fitting', 'admin']}>
                <FittingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FittingShopQrList"
            element={
              <ProtectedRoute allowedRoles={['fitting', 'admin']}>
                <FittingShopQrList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FittingShopQrUpload"
            element={
              <ProtectedRoute allowedRoles={['fittingmanager', 'admin']}>
                <FittingShopQrUpload />
              </ProtectedRoute>
            }
          />

          {/* Returns */}
          <Route
            path="/ReturnsDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsDashboardDupe"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ReturnsDashboardDupe />
              </ProtectedRoute>
            }
          />
          <Route
            path="/returns/cyl/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsCylinderEntryV2 />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/returns/cyl/:id"
            element={
              <ProtectedRoute allowedRoles={['admin','returns']}>
                <ReturnsCylinderEntryV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/returns/parts/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsPartsEntryV2 />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/returns/parts/:id"
            element={
              <ProtectedRoute allowedRoles={['admin','returns']}>
                <ReturnsPartsEntryV2 />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/StragglerExport"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <StragglerExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsArchive"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsArchive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsDraft"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsDrafts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsViewerV2"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsViewerV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsDraftMigratorCylToV2"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsDraftMigratorCylToV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsArchiveViewerV2"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsArchiveViewerV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsV2DedupeCleaner"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsV2DedupeCleaner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsV2ExcelExporter"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsV2ExcelExporter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CoilTool"
            element={
              <ProtectedRoute allowedRoles={['admin', 'technical']}>
                <CoilTool />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ThermalStoreTool"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <ThermalStoreTool />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ReturnsMigratorAllToV2"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsMigratorAllToV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PartTemplatesManager"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <PartTemplatesManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/returns/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <ReturnsEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/returns/parts/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'returns']}>
                <PartsReturnEntry />
              </ProtectedRoute>
            }
          />

          {/* Despatch */}
          <Route
            path="/DespatchDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'despatch']}>
                <DespatchDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DespatchReport"
            element={
              <ProtectedRoute allowedRoles={['admin', 'despatch']}>
                <DespatchReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DespatchView"
            element={
              <ProtectedRoute allowedRoles={['admin', 'despatch']}>
                <DespatchView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DespatchDetailView/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'despatch']}>
                <DespatchDetailView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DespatchSummary"
            element={
                <ProtectedRoute allowedRoles={['admin', 'despatch']}>
                  <DespatchSummary />
                </ProtectedRoute>
            }
          />

          {/* Maintenance / PPM */}
          <Route
            path="/MaintenanceDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <MaintenanceDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MaintenanceDashboardSec"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <MaintenanceDashboardSec />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMAssetCreate"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMAssetCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMExport"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMAssetCreate/:assetId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMAssetCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMEngineersAdmin"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMEngineersAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMScheduleJobs"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMScheduleJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMAssetsList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMAssetsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMDailySchedule"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMDailySchedule />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMEngineerPortal"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager', 'maintenance']}>
                <PPMEngineerPortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMPrintSchedule"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager', 'maintenance']}>
                <PPMPrintSchedule />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMCompletedJobs"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintmanager']}>
                <PPMCompletedJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EngineerDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <EngineerDashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/WorkRequest"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <WorkRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/JobsAndRequests"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <JobsAndRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PhotoGallery"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <PhotoGallery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ArchiveBlock"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <ArchiveBlock />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AssetPPMDesigner"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <AssetPPMDesigner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PPMViewerPro"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <PPMViewerPro />
              </ProtectedRoute>
            }
          />
          <Route
            path="/BreakdownArchive"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <BreakdownArchive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ManageMachines"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ManageMachines />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Machines"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance']}>
                <Machines />
              </ProtectedRoute>
            }
          />
          <Route
            path="/JobList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'maintenance', 'operator']}>
                <JobList />
              </ProtectedRoute>
            }
          />

          {/* Stocktake */}
          <Route
            path="/StockComparison"
            element={
              <ProtectedRoute allowedRoles={['stocktake', 'admin']}>
                <StockComparison />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StockTakeForm"
            element={
              <ProtectedRoute allowedRoles={['stocktake', 'admin']}>
                <StockTakeForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StocktakeDashboard"
            element={
              <ProtectedRoute allowedRoles={['stocktake', 'admin']}>
                <StocktakeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DeadStockView"
            element={
              <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
                <DeadStockView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ClearStocktakeScanned"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ClearStocktakeScanned />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ClearOldStocktakeScanned"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <ClearOldStocktakeScanned />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StocktakeToDuplicate"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stocktake']}>
                <StocktakeToDuplicate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PublishDuplicateToLive"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stocktake']}>
                <PublishDuplicateToLive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StocktakeInstructions"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stocktake']}>
                <StocktakeInstructions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DuplicateWarehouse"
            element={
              <ProtectedRoute allowedRoles={['admin', 'stocktake']}>
                <DuplicateWarehouse />
              </ProtectedRoute>
            }
          />

          {/* Sales / Technical */}
          <Route
            path="/SalesDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <SalesDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HelpDeskDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <HelpDeskDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PartsPrices"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <PartsPrices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PartsList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <PartsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/QuoteList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <QuoteList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Quoting/:type"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <Quoting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CopperQuote"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <CopperQuote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SizingList"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <SizingList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CombiSizing"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <CombiSizing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CylinderSizing"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <CylinderSizing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StainlessCylinderSizing"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <StainlessCylinderSizing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StainlessUnventedQuote"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <StainlessUnventedQuote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StainlessVentedQuote"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <StainlessVentedQuote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TechnicalDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <TechnicalDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TechnicalCalculator"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <TechnicalCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HeatUpCalculator"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <HeatUpCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ExpansionVesselCalculator"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <ExpansionVesselCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CylinderSizingCalculator"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <CylinderSizingCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TimeRequiredCalculator"
            element={
              <ProtectedRoute allowedRoles={['admin', 'office']}>
                <TimeRequiredCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesWarehouse"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <SalesWarehouse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesRepStock"
            element={
              <ProtectedRoute allowedRoles={['admin', 'salesrep']}>
                <SalesWarehouse stockOnly />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CustomerStockReport"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales', 'warehouse']}>
                <CustomerStockReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MerchantMap"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <MerchantMap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SketchPads"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <SketchPads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SalesRepSearch"
            element={
              <ProtectedRoute allowedRoles={['admin', 'sales']}>
                <SalesRepSearch />
              </ProtectedRoute>
            }
          />

          {/* Production */}
          <Route
            path="/ProductionDashboard"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <ProductionDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DailyProduction"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <DailyProduction />
              </ProtectedRoute>
            }
          />

          {/* Misc */}
          <Route
            path="/CSVUploader"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <CSVUploader />
              </ProtectedRoute>
            }
          />
          <Route
            path="/LeadTimeManager"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <LeadTimeManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StockSalesWarehouseLinker"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <StockSalesWarehouseLinker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StockMinLevels"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <StockMinLevels />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StockMinLevelsBulkAdd"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <StockMinLevelsBulkAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CylInfoExcelManager"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <CylInfoExcelManager />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/StockAllocation"
            element={
              <ProtectedRoute allowedRoles={['admin', 'production']}>
                <StockAllocation />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
